/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );
  window.addEventListener("resize", function () {
    accordionItems.forEach(function (item) {
      if (item.closest(".accordion__item").classList.contains("accordion__item--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - Person accordions
    ========================================================================== */

const accordionTiles = document.querySelectorAll(".tile--person--accordion--hasbio .tile__header");

const accordionTilesInit = function (accordionTiles) {
  if (!accordionTiles) {
    return;
  }

  accordionTiles.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".tile--person--accordion").classList.toggle("tile--person--accordion--open");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );

  window.addEventListener("resize", function () {
    accordionTiles.forEach(function (item) {
      if (item.closest(".tile--person--accordion").classList.contains("tile--person--accordion--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // accordionTilesInit();
accordionTilesInit(accordionTiles);

/*  ==========================================================================
    GENERAL - Team accordions
    ========================================================================== */

const teamAccordions = document.querySelectorAll(".featured-people__team__header");

const teamAccordionsInit = function (teamAccordions) {
  if (!teamAccordions) {
    return;
  }

  teamAccordions.forEach(item =>
    item.addEventListener("click", function () {
      let panel = this.nextElementSibling;
      if (item.closest(".featured-people__team").classList.contains("featured-people__team--open")) {
        // Close all items and remove the fade out (e.g. the --hide class)
        teamAccordions.forEach(function (e) {
          e.closest(".featured-people__team").classList.remove("featured-people__team--open");
          e.closest(".featured-people__team").classList.remove("featured-people__team--hide");
          let panel = e.nextElementSibling;
          panel.style.maxHeight = null;
        });
      } else {
        // Close and fade out others
        teamAccordions.forEach(function (e) {
          e.closest(".featured-people__team").classList.remove("featured-people__team--open");
          e.closest(".featured-people__team").classList.add("featured-people__team--hide");
          let panel = e.nextElementSibling;
          panel.style.maxHeight = null;
        });
        // Open item
        item.closest(".featured-people__team").classList.remove("featured-people__team--hide");
        item.closest(".featured-people__team").classList.add("featured-people__team--open");
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );

  window.addEventListener("resize", function () {
    teamAccordions.forEach(function (item) {
      if (item.closest(".featured-people__team").classList.contains("featured-people__team--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // teamAccordionsInit();
teamAccordionsInit(teamAccordions);

/*  ==========================================================================
    GENERAL - Subjects accordions
    ========================================================================== */

const subjectAccordions = document.querySelectorAll(".subjects__area__header");

const subjectAccordionsInit = function (subjectAccordions) {
  if (!subjectAccordions) {
    return;
  }

  subjectAccordions.forEach(item =>
    item.addEventListener("click", function () {
      let panel = this.nextElementSibling;
      if (item.closest(".subjects__area").classList.contains("subjects__area--open")) {
        // Close all items and remove the fade out (e.g. the --hide class)
        subjectAccordions.forEach(function (e) {
          e.closest(".subjects__area").classList.remove("subjects__area--open");
          e.closest(".subjects__area").classList.remove("subjects__area--hide");
          let panel = e.nextElementSibling;
          panel.style.maxHeight = null;
        });
      } else {
        // Close and fade out others
        subjectAccordions.forEach(function (e) {
          e.closest(".subjects__area").classList.remove("subjects__area--open");
          e.closest(".subjects__area").classList.add("subjects__area--hide");
          let panel = e.nextElementSibling;
          panel.style.maxHeight = null;
        });
        // Open item
        item.closest(".subjects__area").classList.remove("subjects__area--hide");
        item.closest(".subjects__area").classList.add("subjects__area--open");
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );
  window.addEventListener("resize", function () {
    subjectAccordions.forEach(function (item) {
      if (item.closest(".subjects__area").classList.contains("subjects__area--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // subjectAccordionsInit();
subjectAccordionsInit(subjectAccordions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
		GENERAL - Notification Popup
		========================================================================== */

const notificationPopupInit = function () {
  const notificationPopup = document.querySelector(".notificationpopup");
  const notificationPopupClose = document.querySelector(".notification__close");

  if (!notificationPopup) {
    return;
  }

  const notifcationId = notificationPopup.id;

  if (!Cookies.get(notifcationId)) {
    notificationPopup.classList.add("notificationpopup--active");
  }

  notificationPopupClose.addEventListener("click", function (e) {
    notificationPopup.classList.remove("notificationpopup--active");
    Cookies.set(notificationPopup.id, true, { expires: 7 });
  });
}; // notificationPopupInit();
notificationPopupInit();

/*  ==========================================================================
    GENERAL - Pagenav & anchor
    ========================================================================== */

const pagenav = document.querySelector(".pagenav");

const pagenavInit = function (pagenav) {
  if (!pagenav) {
    return;
  }

  new Waypoint({
    element: document.querySelector(".pageheader"),
    handler: function (direction) {
      if (direction === "down") {
        pagenav.classList.add("pagenav--show");
      } else {
        pagenav.classList.remove("pagenav--show");
      }
    },
    offset: "-20%"
  });

  new Waypoint({
    element: document.querySelector(".sitefooter"),
    handler: function (direction) {
      if (direction === "down") {
        pagenav.classList.add("pagenav--hide");
      } else {
        pagenav.classList.remove("pagenav--hide");
      }
    },
    offset: "100%"
  });

  const pagenavLinks = document.querySelectorAll(".pagenav__link");
  pagenavLinks.forEach(navLink =>
    navLink.addEventListener("click", function () {
      document.querySelector(this.getAttribute("href")).scrollIntoView({ behavior: "smooth", block: "start" });
    })
  );
}; // pagenavInit();
pagenavInit(pagenav);

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    let buttonHTML; // create variable to store button text
    buttonHTML = button.innerHTML;
    button.innerHTML = '<span class="arrow">Loading...</span>';

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      // Restore the previous button HTML (including any spans)
      button.innerHTML = buttonHTML;

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page
  const currentPage = new URL(window.location);
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonHTML; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonHTML = button.innerHTML;
      button.innerHTML = '<span class="arrow">Loading...</span>';
    },
    success: function (data) {
      if (data) {
        // Restore the previous button HTML (including any spans)
        button.innerHTML = buttonHTML;

        // Insert new posts into the loadmore container
        loadmoreContainer.innerHTML += data;

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Text fade in
    ========================================================================== */

const textFadeInInit = function () {
  const textFades = document.querySelectorAll(".text-fade:not(.text-fade--ready)");

  if (textFades.length > 0) {
    textFades.forEach(function (textFade) {
      // setup lettering
      var fadeHTML = textFade.innerHTML.replace(/(?![^<]*>)[^<]/g, c => `<span>${c}</span>`);
      textFade.innerHTML = fadeHTML;
      // setup waypoint
      new Waypoint({
        element: textFade,
        handler: function (direction) {
          if (direction === "down") {
            textFade.classList.add("text-fade--ready");
          } else {
            textFade.classList.remove("text-fade--ready");
          }
        },
        offset: "90%"
      });
    });
  }
};

textFadeInInit();

/*  ==========================================================================
    Homepage animation
    ========================================================================== */

const rotatingWords = document.querySelector(".pageheader__rotatingwords");

const rotatingWordsInit = function (rotatingWords) {
  if (!rotatingWords) {
    return;
  }

  let interval;

  const auto = () => {
    if (interval) {
      clearInterval(interval);
    }
    interval = setInterval(() => {
      const nextWord = document.querySelector(
        ".pageheader__rotatingwords .pageheader__rotatingwords__word--active"
      ).nextElementSibling;
      if (nextWord) {
        document
          .querySelector(".pageheader__rotatingwords__word--active")
          .classList.remove("pageheader__rotatingwords__word--active");
        nextWord.classList.add("pageheader__rotatingwords__word--active");
      } else {
        document
          .querySelector(".pageheader__rotatingwords__word--active")
          .classList.remove("pageheader__rotatingwords__word--active");
        document
          .querySelector(".pageheader__rotatingwords__word:first-child")
          .classList.add("pageheader__rotatingwords__word--active");
      }
    }, 2500);
  };
  auto();
};
rotatingWordsInit(rotatingWords);

/*  ==========================================================================
    Pinned Scroll List
    ========================================================================== */

const pinnedLists = document.querySelectorAll(".pinned-list");

const pinnedListsInit = function (pinnedLists) {
  if (!pinnedLists) {
    return;
  }

  pinnedLists.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        let module = val.closest(".module--pinned-scroll-list");
        module.querySelectorAll(".pinned-img__img").forEach(function (item) {
          item.classList.remove("active");
        });
        module.querySelector("." + val.dataset.swap).classList.add("active");
        module.querySelectorAll(".pinned-list").forEach(function (item) {
          item.classList.remove("active");
        });
        val.classList.add("active");
      },
      offset: "30%"
    });
  });
}; // pinnedListsInit();
pinnedListsInit(pinnedLists);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    if (elem.closest(".row--carousel").classList.contains("row--carousel--listgrid")) {
      // If its a list grid carousel, disable the nav on mobile, and turn it on on tablet
      responsiveArray["0"].nav = false;
      responsiveArray["550"].nav = false;
      responsiveArray["700"] = {};
      responsiveArray["700"].nav = true;
    }

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    const fadeIn = elem.dataset.fade ? "fadeIn" : false;
    const fadeOut = elem.dataset.fade ? "fadeOut" : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      animateIn: fadeIn,
      animateOut: fadeOut,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - collapse menu on scroll
	========================================================================== */
let scrollpos = window.scrollY;
window.addEventListener("scroll", function () {
  scrollpos = window.scrollY;

  if (scrollpos >= 50) {
    document.querySelector(".sitenav").classList.add("sitenav--collapse");
  } else {
    document.querySelector(".sitenav").classList.remove("sitenav--collapse");
  }
});

/*  ==========================================================================
	NAVIGATION - mobnav / full screen nav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    let mobnavHeight = 0;
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      mobnavSetHeight();
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);

      // Close all sub navs
      if (document.querySelectorAll(".mobnav__subnav")) {
        document.querySelectorAll(".mobnav__subnav").forEach(function (mobnavSubnav) {
          mobnavSubnav.classList.remove("mobnav__subnav--active");
        });
      }
    }
  });
}; // mobnavInit()
mobnavInit();

// On resize check mobnav height is still right
const mobnavResize = function () {
  let mobnavHeight = 0;
  if (body.classList.contains(mobnavOpenclass)) {
    mobnavSetHeight();
  }
}; // mobnavResize()

window.addEventListener(
  "resize",
  function (event) {
    mobnavResize();
  },
  true
);

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .mobnav__primarynav__link--hassubnav");
const mobnavCloseLinks = document.querySelectorAll(".mobnav__subnav__close");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = mobnavLink.dataset.nav;
      // hide current active nav
      if (document.querySelector(".mobnav__subnav--active")) {
        // Fade out (had to use jquery just for the fadeout animation)
        $(".mobnav__subnav--active").fadeOut(250, function () {
          // and then Remove active class
          document.querySelector(".mobnav__subnav--active").classList.remove("mobnav__subnav--active");
          // show new nav
          if (document.querySelector("#mobnav__subnav--" + mobnavTargetSection)) {
            $("#mobnav__subnav--" + mobnavTargetSection).fadeIn(250, function () {
              document.querySelector("#mobnav__subnav--" + mobnavTargetSection).classList.add("mobnav__subnav--active");
            });
          }
        });
      } else {
        // Show first sub nav
        if (document.querySelector("#mobnav__subnav--" + mobnavTargetSection)) {
          $("#mobnav__subnav--" + mobnavTargetSection).fadeIn(250, function () {
            document.querySelector("#mobnav__subnav--" + mobnavTargetSection).classList.add("mobnav__subnav--active");
          });
        }
      }
    });
  });

  if (!mobnavCloseLinks) {
    return;
  }

  mobnavCloseLinks.forEach(function (mobnavCloseLink) {
    mobnavCloseLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = mobnavCloseLink.closest(".mobnav__subnav");
      if (mobnavTargetSection) {
        $(mobnavTargetSection).fadeOut(250, function () {
          // and then Remove active class
          mobnavTargetSection.classList.remove("mobnav__subnav--active");
        });
      }
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();
